import axios from 'axios'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getDisasterSettingByArea(condition = {}) {
  let response = {}

  if (Utils.isEmptyObject(condition.id)) {
    console.error('iisi GetDisasterSettingByArea: scenicAreaId is null')

  }

  let scenicAreaId = condition.id
  let scenicAreaIdQuery = `?scenicAreaId=${scenicAreaId}`

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}DisasterSetting/GetDisasterSettingByArea${scenicAreaIdQuery}`)

  } catch (err) {
    console.error('iisi GetDisasterSettingByArea: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function postMutiDisasterSetting (condition = {}) {
  let response = {}

  if (Utils.isEmptyObject(condition.DisasterData)) {
    console.error('iisi addMutiDisasterSetting: DisasterData is null')
    return
  }

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}DisasterSetting/AddMutiDisasterSetting`, condition.DisasterData)

  } catch (err) {
    console.error('iisi addMutiDisasterSetting: ', err)
  }

  Utils.setApiResponsSuccess(response)
  console.log('response: ', response)
  return response
}